:host {
  --aha-ez-tab--hovered-color: var(--aha-blue-500);
  --aha-ez-tab--selected-indicator-height: 0;
  --aha-ez-tab--selected-indicator-color: var(--aha-blue-500);
  --aha-ez-tab--font-size: 14px;

  display: flex;
  gap: 1ex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  margin: 0 var(--spacer-4);
  padding: var(--spacer-2) 0;
  user-select: none;
  position: relative;
  font-weight: 600;
  font-size: var(--aha-ez-tab--font-size);
  text-transform: uppercase;
  color: var(--theme-secondary-text);
}

#border {
  width: 100%;
  height: var(--aha-ez-tab--selected-indicator-height);
  position: absolute;
  left: 0;
  bottom: -1px;
  background: var(--aha-ez-tab--selected-indicator-color);
  pointer-events: none;
}
:host(:where([disabled], [inert])) {
  cursor: not-allowed;
}
:host(:where(:hover, :focus-visible)) {
  color: var(--aha-ez-tab--hovered-color);
}
:host(:where([aria-selected='true'])) {
  cursor: default;
  color: var(--aha-ez-tab--hovered-color);
  --aha-ez-tab--selected-indicator-height: 3px;
}
